  import React from 'react';
  import { Activity } from 'lucide-react';

  export default function LogsTable({ logs }) {
    if (!logs || logs.length === 0) {
      return (
        <div className="p-8 text-center border-t border-slate-100 dark:border-slate-800">
          <p className="text-slate-500 dark:text-slate-400">No system logs found.</p>
        </div>
      );
    }

    return (
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50 dark:bg-[#0b1220] border-b border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-400 text-sm uppercase tracking-wider">
              <th className="p-4 font-medium w-16"></th>
              <th className="p-4 font-medium">Action</th>
              <th className="p-4 font-medium">Details</th>
              <th className="p-4 font-medium">Time</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-b border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                <td className="p-4 align-top">
                  <div className="w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-500 dark:text-slate-400">
                    <Activity size={14} />
                  </div>
                </td>
                <td className="p-4 align-top font-medium text-slate-900 dark:text-white">
                  {log.action ?? "-"}
                </td>
                <td className="p-4 align-top text-slate-600 dark:text-slate-300">
                  {log.details ?? "-"}
                </td>
                <td className="p-4 align-top text-sm text-slate-500 dark:text-slate-400 whitespace-nowrap">
                  {log.created_at ? new Date(log.created_at).toLocaleString() : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
